export type LayoutID =
  | "QWERTY_USUK"
  | "QWERTZ_DECH"
  | "AZERTY_FR";

export type LayoutConfig = {
  id: LayoutID;
  origin: string;
  KeyS: string,
  KeyD: string,
  KeyF: string,
  KeyK: string,
  KeyL: string,
  Semicolon: string,
  forwardSpeedUpKey: string;
  backwardSlowDownKey: string;
  replayKey: string,
  spaceKey: string,
  keyboardLayoutHeadquarterSrc: string;
  spaceBarFeedbackKeysM1: string;
};

export const LAYOUT_CONFIGS: LayoutConfig[] = [
  {
    id: "QWERTY_USUK",
    origin: "USA, UK, Canada",
    KeyS: "S",
    KeyD: "D",
    KeyF: "F",
    KeyK: "K",
    KeyL: "L",
    Semicolon: ";",
    forwardSpeedUpKey: "/",
    backwardSlowDownKey: "Z",
    replayKey: "R",
    spaceKey: "Space",
    keyboardLayoutHeadquarterSrc: "assets/images/headquarter/QWERTY_USUK/",
    spaceBarFeedbackKeysM1: "assets/images/instructions/m1/QWERTY_USUK/",
  },
  {
    id: "QWERTZ_DECH",
    origin: "Germany, Switzerland",
    KeyS: "S",
    KeyD: "D",
    KeyF: "F",
    KeyK: "K",
    KeyL: "L",
    Semicolon: "Ö",
    forwardSpeedUpKey: "-",
    backwardSlowDownKey: "Y",
    replayKey: "R",
    spaceKey: "Space",
    keyboardLayoutHeadquarterSrc: "assets/images/headquarter/QWERTZ_DECH/",
    spaceBarFeedbackKeysM1: "assets/images/instructions/m1/QWERTZ_DECH/",
  },
  {
    id: "AZERTY_FR",
    origin: "France",
    KeyS: "S",
    KeyD: "D",
    KeyF: "F",
    KeyK: "K",
    KeyL: "L",
    Semicolon: "M",
    forwardSpeedUpKey: "!",
    backwardSlowDownKey: "W",
    replayKey: "R",
    spaceKey: "Space",
    keyboardLayoutHeadquarterSrc: "assets/images/headquarter/AZERTY_FR/",
    spaceBarFeedbackKeysM1: "assets/images/instructions/m1/AZERTY_FR/",
  },
];

const DETECTED_LAYOUT_TO_ID: Record<string, LayoutID> = {
  "QWERTY_US": "QWERTY_USUK",
  "QWERTY_UK": "QWERTY_USUK",
  "QWERTZ_DE": "QWERTZ_DECH",
  "QWERTZ_CH": "QWERTZ_DECH",
  "AZERTY_FR": "AZERTY_FR",
};

export function mapDetectedLayoutToLayoutId(detectedLayout?: string): LayoutID {
  return DETECTED_LAYOUT_TO_ID[detectedLayout ?? ""] ?? "QWERTY_USUK";
}

export function getLayoutConfigById(layoutId: LayoutID): LayoutConfig {
  return LAYOUT_CONFIGS.find((layoutConfig) => layoutConfig.id === layoutId) ?? LAYOUT_CONFIGS[0];
}

export function getLayoutConfigByDetectedLayout(detectedLayout?: string): LayoutConfig {
  return getLayoutConfigById(mapDetectedLayoutToLayoutId(detectedLayout));
}
